import svgToBase64Uri from "@/utils/svgToBase64URI";

import type { Icon } from "./types";

export default function base64URL(icon: Icon, params?: Record<string, string>) {
	const { H, W, body } = icon;
	const fill = params?.fill ?? "none";
	return svgToBase64Uri(`
    <svg
      width="${W}"
      height="${H}"
      viewBox="0 0 ${W} ${H}"
      fill="${fill}"
      xmlns="http://www.w3.org/2000/svg"
    >${body(params)}</svg>
  `);
}
